import React from "react";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LegalDocumentsList } from "../../../components/LegalDocumentsList";

/** Exhibitor cabinet — always-available legal docs (open / download). */
export function ExhibitorDocumentsPage() {
  const { i18n } = useTranslation();
  const isEn = i18n.language.toLowerCase().startsWith("en");

  return (
    <div className="p-4 sm:p-6 max-w-lg mx-auto space-y-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-slate-100 text-slate-600 flex items-center justify-center flex-shrink-0">
          <FileText size={18} />
        </div>
        <div>
          <h1 className="text-[19px] text-gray-900">
            {isEn ? "Documents" : "Документы"}
          </h1>
          <p className="text-[13px] text-gray-400 mt-0.5">
            {isEn
              ? "Open or download MVK One legal documents"
              : "Открыть или скачать юридические документы MVK One"}
          </p>
        </div>
      </div>
      <LegalDocumentsList />
    </div>
  );
}
